import type { ComputedRef } from 'vue'
import { usarCatalogoQuery, usarContextoCatalogo, type EstadoCatalogoQuery } from '@next/compartilhados/catalogos'
import { DESCRITOR_CATALOGO_USUARIO, type OpcaoUsuario } from '../catalogo-usuario.tipos'
import { usarOperacoesCatalogoUsuario } from './catalogo-usuario.injecao'
export const usarCatalogoUsuario = (
  habilitado?: ComputedRef<boolean>,
): EstadoCatalogoQuery<OpcaoUsuario> => usarCatalogoQuery({
  catalogo: DESCRITOR_CATALOGO_USUARIO,
  contexto: usarContextoCatalogo(),
  consultar: usarOperacoesCatalogoUsuario().listarOpcoes,
  ...(habilitado ? { habilitado } : {}),
})
